import { Maybe, MutationResolvers, PastSearch } from '../../../generated/graphql'
import query from './getPastSearches'

const MAX_SEARCH_LENGTH = 11

type QueryType = {
    pastSearches: Maybe<PastSearch[]>
}

const addPastSearch: MutationResolvers['addPastSearch'] = (_root, { input }, { cache }): boolean => {
    try {
        if (!cache) {
            throw new Error('Missing client context')
        }

        const data = cache.readQuery<QueryType>({ query })
        let pastSearches = data?.pastSearches ?? []

        // check the new search against the list
        const found = pastSearches.find(
            ({ searchName, filterName }) => searchName === input.searchName && filterName === input.filterName,
        )
        if (found) {
            return true
        }

        const newSearch = { ...input, __typename: 'PastSearch' as const }

        pastSearches = [newSearch, ...pastSearches]
        // check the length of the array to be no longer than MAX_SEARCH_LENGTH
        pastSearches.slice(pastSearches.length >= MAX_SEARCH_LENGTH ? 1 : 0, MAX_SEARCH_LENGTH).concat()

        cache.writeData({
            data: {
                pastSearches,
            },
        })
    } catch (error) {
        console.log(error)
    }

    return false
}

export default addPastSearch
